import {useCallback, useMemo} from 'react'
import {Box, Button} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../common/store'
import {addText, selectActiveScene} from '../../../common/components/store/scenesSlice'
import {useAppTokens} from '../../theme'
import type {ThemeTokens} from '../../theme'
import Text2DItem from './Text2DItem'

// ── Text2DPanel — add button + list of 2D text items ──────────────

const Text2DPanel = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const tokens = useAppTokens()
  const texts = useAppSelector((s) => selectActiveScene(s).texts)
  const sx = useMemo(() => buildStyles(tokens), [tokens])

  const handleAdd = useCallback(() => {
    dispatch(addText())
  }, [dispatch])

  return (
    <Box>
      <Button variant="outlined" size="small" fullWidth startIcon={<AddIcon />} onClick={handleAdd} sx={sx.addButton}>
        {t('text2d.addText')}
      </Button>
      <Box sx={sx.list}>
        {texts.map((text) => (
          <Text2DItem key={text.id} text={text} />
        ))}
      </Box>
    </Box>
  )
}

const buildStyles = (tokens: ThemeTokens) => ({
  addButton: {
    fontSize: 12,
    textTransform: 'none' as const,
    color: tokens.text.primary,
    borderColor: tokens.accordion.border,
    marginBottom: '8px',
    '&:hover': {
      borderColor: tokens.text.secondary,
    },
  },
  list: {
    display: 'flex',
    flexDirection: 'column' as const,
  },
})

export default Text2DPanel
